import GalaxyFilamentWordmark from "@galaxy-io/dls/brand/GalaxyFilamentWordmark";
import GalaxyWordmark from "@galaxy-io/dls/brand/GalaxyWordmark";
import Text, { TextSize, TextVariant } from "@galaxy-io/dls/text/Text";
import { FontFamily } from "@galaxy-io/dls/theme/enums";
import type { ReactNode } from "react";
import styles from "./auth-layout.module.css";
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className={styles.page}>
      <aside className={styles.story}>
        <div className={styles.brand}>
          <GalaxyWordmark size={22} />
          <Text variant={TextVariant.TERTIARY} family={FontFamily.MONO}>
            GTM
          </Text>
        </div>
        <div className={styles.products}>
          <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY} family={FontFamily.MONO}>
            PRODUCTS
          </Text>
          <div className={styles.filamentLockup}>
            <div className={styles.filamentLogo} role="img" aria-label="Filament">
              <GalaxyFilamentWordmark size={20} />
            </div>
            <Text family={FontFamily.SERIF}>Our data movement engine</Text>
          </div>
        </div>
      </aside>
      <section className={styles.entry}>
        <div className={styles.mobileBrand}>
          <GalaxyWordmark size={20} />
          <Text variant={TextVariant.TERTIARY} family={FontFamily.MONO}>
            GTM
          </Text>
        </div>
        <div className={styles.form}>{children}</div>
      </section>
    </main>
  );
}
export { styles as authStyles };
